class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.closeAnimationTimeout = null;
    this.openAnimationFrame = null;

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    const details = event.target.closest('details');

    if (!details.hasAttribute('open') || this.classList.contains('search-closing')) {
      this.open(event);
    } else {
      this.close();
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    clearTimeout(this.closeAnimationTimeout);
    cancelAnimationFrame(this.openAnimationFrame);
    this.classList.remove('search-open');
    this.classList.remove('search-closing');

    const openHeaderDrawer = document.querySelector('header-drawer details[open]');

    if (openHeaderDrawer) {
      const headerDrawer = openHeaderDrawer.closest('header-drawer');
      headerDrawer.closeMenuDrawer(event, headerDrawer.querySelector('summary'));
      openHeaderDrawer.removeAttribute('open');
    }

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    const isHeaderSearch = this.classList.contains('header__search');

    if (isHeaderSearch) {
      this.detailsContainer.getBoundingClientRect();
      this.openAnimationFrame = requestAnimationFrame(() => this.classList.add('search-open'));
    } else {
      document.body.classList.add('overflow-hidden');
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    document.body.removeEventListener('click', this.onBodyClickEvent);

    const isHeaderSearch = this.classList.contains('header__search');

    const animateSearchClose =
      isHeaderSearch &&
      this.detailsContainer.open &&
      this.classList.contains('search-open') &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    clearTimeout(this.closeAnimationTimeout);
    cancelAnimationFrame(this.openAnimationFrame);
    this.classList.remove('search-open');

    if (!animateSearchClose) {
      this.detailsContainer.removeAttribute('open');
      this.classList.remove('search-closing');
      if (!isHeaderSearch) document.body.classList.remove('overflow-hidden');
      return;
    }

    this.classList.add('search-closing');
    this.closeAnimationTimeout = setTimeout(() => {
      this.detailsContainer.removeAttribute('open');
      this.classList.remove('search-closing');
    }, 180);
  }
}

customElements.define('details-modal', DetailsModal);
